import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter' })
export class FilterCollectionPipe implements PipeTransform {
    transform(data: any, key: string, search: string | number, returnVacio: boolean): any {
        if (returnVacio && !search) return [];
        if (!data) return [];
        if (!search && !returnVacio) return data;
        return data.filter((x: any) => x[key].toString().toLowerCase().includes(search.toString().toLowerCase()));
    }
}
